// extracted by mini-css-extract-plugin
module.exports = {"leftAligned":"styles_leftAligned__3A-ib","centerAligned":"styles_centerAligned__3qaR6"};